import { ILocationWarehouseGroup } from '../../location/interfaces/location.interface';
import { IRfq } from '../../rfq/interfaces/rfq.interface';

export interface IStockStatus {
  stockStatus :EStockStatusValue;
  stockStatusCount :number;
}

export enum EStockStatusValue {
  IN_STOCK = 'IN_STOCK',
  REORDER_LEVEL = 'LOW_STOCK',
  MINIMUM_STOCK = 'OUT_OF_STOCK',
}

export enum EStockStatus {
  IN_STOCK = 'In Stock',
  LOW_STOCK = 'Re-Order Level',
  OUT_OF_STOCK = 'Minimum Stock',
}

export interface IStockGroup {
  identifier :any;
  count :number;
  group :string;
  field :string;
  label :string;
}

export interface IStock {
  uniqueId :string;
  productType :string;
  categoryId :number;
  subCategoryId :number;
  categoryName :string;
  subCategoryName :string;
  warehouseGroupId :number;
  warehouseGroupLabel :string;
  stockStatus :string;
  incomingQty :number;
  onHandQty :number;
  pendingQty :number;
  availableQty :number;
  productName :string;
  internalSku :string;
  rfqId :number;
  rfq :IRfq;
}

export interface IStockOptions {
  value :number;
  label :string;
  checked :boolean;
}
